import { client } from "Service/axios";
import {
  ANNOUNCEMENTS,
  ANNOUNCEMENTS_MARK_ALL_READ,
  ANNOUNCEMENTS_MARK_READ,
  ANNOUNCEMENTS_UNREAD_COUNT,
} from "Shared/Constants/apiRequest";

class Announcements {
  getAnnouncements(params: any) {
    return client.get<any>(ANNOUNCEMENTS, {
      params,
    });
  }
  markAnnouncementAsRead(id: string) {
    return client.post<any>(ANNOUNCEMENTS_MARK_READ(id));
  }
  getUnreadCount() {
    return client.get<any>(ANNOUNCEMENTS_UNREAD_COUNT);
  }
  markAnnouncementAsReadAll() {
    return client.post<any>(ANNOUNCEMENTS_MARK_ALL_READ);
  }
}

export default Announcements;
